import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { CountryWithIcon } from '@entities/country';
import { CountryPicker } from '@features/country/select-country';
import { useCyberStore, TspPageDenomination, TspPagePayee } from '@entities/tsp';
import { DenominationAmountByServiceIdType } from '@entities/denomination';
import DenominationList from './DenominationList';
interface ServiceDenominationListWithCountryPickerProps {
  payee: TspPagePayee;
  countries: CountryWithIcon[];
  denominationsByCountry: Record<string, TspPageDenomination[]>;
  pricesByServiceId: DenominationAmountByServiceIdType;
}
const ServiceDenominationListWithCountryPicker: FC<ServiceDenominationListWithCountryPickerProps> = ({
  payee,
  countries,
  denominationsByCountry,
  pricesByServiceId
}) => {
  const {
    activeCountry
  } = useCyberStore();
  return <ServiceDenominationListWithCountryPickerWrapper>
      <CountryPickerWrapper>
        <CountryPicker countries={countries} />
      </CountryPickerWrapper>
      <DenominationListWrapper>
        {activeCountry && <DenominationList payee={payee} denominations={denominationsByCountry[activeCountry] || denominationsByCountry[countries[0]?.country]} pricesByServiceId={pricesByServiceId} />}
      </DenominationListWrapper>
    </ServiceDenominationListWithCountryPickerWrapper>;
};
export default ServiceDenominationListWithCountryPicker;
const ServiceDenominationListWithCountryPickerWrapper = /*#__PURE__*/styled('div')({
  name: "ServiceDenominationListWithCountryPickerWrapper",
  class: "s41vpsj",
  propsAsIs: false
});
const CountryPickerWrapper = /*#__PURE__*/styled('div')({
  name: "CountryPickerWrapper",
  class: "crgk43l",
  propsAsIs: false
});
const DenominationListWrapper = /*#__PURE__*/styled('div')({
  name: "DenominationListWrapper",
  class: "dome2w6",
  propsAsIs: false
});

require("./ServiceDenominationListWithCountryPicker.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./ServiceDenominationListWithCountryPicker.tsx");